import conditionsCommon from "./reusable/conditionsCommon";

/**
 * Mixin used for handling 'Enable/Disable field' conditions.
 */
export default {
  data: function () {
    return {
      fieldRequiredMap: {}
    }
  },
  mixins: [conditionsCommon],
  methods: {
    renderRequiredConditions() {
      this.clearObject(this.fieldRequiredMap)

      this.validationConditions.forEach(validationCondition => {
        let conditionMet = false;

        let sourceValue = this.formData[validationCondition.field];

        const isEqual = ((typeof sourceValue == 'object' && sourceValue.includes(validationCondition.value)) || sourceValue === validationCondition.value);

        if (validationCondition.state === 'equalTo') {
          conditionMet = isEqual;
        }

        if (validationCondition.state === 'notEqualTo') {
          conditionMet = !isEqual;
        }

        if (conditionMet) {
          this.fieldRequiredMap[validationCondition.targetField] = validationCondition.action === 'setRequired';
        }
      });
    },
    isFieldRequired(field) {
      if (this.fieldRequiredMap.hasOwnProperty(field.name)) {
        return this.fieldRequiredMap[field.name]
      }

      if (field.hasOwnProperty('by_participant') && field.by_participant && !this.isParticipantSubmission) {
        return false;
      }

      return !!field.required;
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/formRender/requiredFieldConditions.js